import React, { useState } from 'react';
import { formatThousands } from '../../../lib/helpers';

const InputMoney = ({ inputProps }) => {
  const [isEditing, setIsEditing] = useState(false);

  const toggleEditing = status => {
    setIsEditing(!isEditing);
  };

  return (
    <div className="form__input-group">
      <span className="form__input-group-addon">
        <i className="fa fa-usd" aria-hidden="true" />
      </span>
      {isEditing === true ? (
        <input
          {...inputProps}
          value={inputProps.value}
          onBlur={toggleEditing}
          type="tel"
          className="form__input"
        />
      ) : (
        <input
          {...inputProps}
          value={formatThousands(inputProps.value.replace(/,/g, ''))}
          onFocus={toggleEditing}
          type="text"
          className="form__input"
        />
      )}
    </div>
  );
};

export default InputMoney;
